document.addEventListener("DOMContentLoaded", function () {
  // Product Gallery
  if (!document.querySelector("variant-radios")) {
    if (document.querySelectorAll(".product-imageslide .swiper-slide").length > 0) {
      console.log("product.js")
      document.querySelectorAll(".gallery-top").forEach((item) => {
        const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, {
          direction: item.dataset.direction,
          slidesPerView: 4,
          spaceBetween: 10,
          mousewheel: true,
          freeMode: true,
          breakpoints: {
            0: {
              direction: "horizontal",
            },
            769: {
              direction: item.dataset.direction,
            },
          },
        })
        const sliderImages = new Swiper(item, {
          direction: item.dataset.direction,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 1000,
          mousewheel: false,
          grabCursor: false,
          allowTouchMove: false,
          thumbs: {
            swiper: sliderThumbs,
          },
          navigation: {
            nextEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild,
            prevEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          pagination: {
            el: item.querySelector(".swiper-pagination"),
            clickable: true,
            type: "progressbar",
          },
          // scrollbar: {
          //   el: item.firstElementChild.nextElementSibling,
          // },
          breakpoints: {
            0: {
              direction: "horizontal",
              mousewheel: false,
              allowTouchMove: true,
              pagination: {
                clickable: true,
                type: "bullets",
              },
            },
            769: {
              direction: item.dataset.direction,
              allowTouchMove: false,
              pagination: {
                clickable: true,
                type: "progressbar",
              },
            },
          },
        })
      })
    }
  }
})

//jQuery
;(function ($) {
  //Product image popup
  $(".js-zoom-image").magnificPopup({
    type: "image",
    tLoading: "Loading image #%curr%...",
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
    },
    image: {},
    callbacks: {
      resize: function () {
        let heightLoadImg = this.content.find("img").height()
        this.content.find("img").addClass("smallSize")
        this.content.find("img").on("click", function () {
          if ($(this).hasClass("smallSize")) {
            $(this).css("max-height", "100%")
            $(this).removeClass("smallSize")
          } else {
            $(this).css("max-height", heightLoadImg)
            $(this).addClass("smallSize")
          }
        })
      },
      imageLoadComplete: function () {
        this.content.find("img").css("width", "auto")
      },
      change: function () {
        this.content.find("img").css("max-width", "auto")
      },
    },
  })
  //Product gallery popup
  $(".js-zoom-gallery").magnificPopup({
    type: "image",
    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: "auto",
    removalDelay: 300, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function () {
        // just a hack that adds mfp-anim class to markup
        this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim")
        this.st.mainClass = "mfp-zoom-in"
        setTimeout(function () {
          if (document.querySelectorAll(".mfp-arrow-left").length > 0) {
            document.querySelector(".mfp-arrow-left").innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gall-nav-icon icon-chleft"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg>
                `
            document.querySelector(".mfp-arrow-right").innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gall-nav-icon icon-chright"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg>
                `
          }
        }, 300)
      },
      change: function () {},
    },
    closeBtnInside: true,
    preloader: false,

    midClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1],
    },
  })
  //replace gallery nav icons
})(jQuery) //jQuery*/
